import React from "react";
import { useUserContext } from "context/UserContext";
import AgentManagementBK from "layouts/BK/agent";
import AgentManagementSP from "layouts/SP/agent";
import AgentManagementCM from "layouts/CM/agent";
import { isBkLikeRole } from "utils/roleUtils";

function AgentManagements() {
  const { role } = useUserContext() || {};
  if (role === "SP") {
    return <AgentManagementSP />;
  }
  if (isBkLikeRole(role)) {
    return <AgentManagementBK />;
  }
  if (role === "CM") {
    return <AgentManagementCM />;
  }
  return null;
}

export default AgentManagements;
